import React, { PureComponent, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import styled, { css } from 'styled-components';

import { capfl } from 'common/utils/index';
import { withCssUnit } from 'common/components/styleguide/utils/index';
import { togglePageModal } from 'common/actions/PageActions';

import { Block } from 'common/components/styleguide/grid';

import { BlockTransparent } from 'common/components/styleguide/grid';
import { Headline1 } from 'common/components/styleguide/Headline';
import Button from 'common/components/styleguide/Button';
import Link from 'common/components/styleguide/Link';
import Alert from 'common/components/styleguide/Alert';
import Emoji from 'common/components/styleguide/Emoji';

import {
  PRODUCT_DICOUNT_HOOK_TYPE,
  PRODUCT_SOFT_HOOK_TYPE
} from 'common/constants/ProductConstants';

import Rating from 'common/components/styleguide/Rating';

import Variants from 'common/components/product/detail/_default/Variants';

import SS from 'common/components/product/_styles';

import loadable from '@loadable/component';
const ProductForm = loadable(() => import('common/blocks/product/detail/form'));
const ProductStatus = loadable(() => import('common/blocks/product/status'));
const AddToWishlist = loadable(() => import('common/blocks/functional/addToWishlistButton'));
const AddToCompare = loadable(() => import('common/blocks/functional/addToCompareButton'));
const Modal = loadable(() => import('common/components/_partials/modal/_default'));
const RequestPriceForm = loadable(() => import('common/blocks/requestPriceForm'));

const S = {};

S.SummaryWrapper = styled.div`
  font-size: ${({ theme }) => _.get(theme, 'product.fontSize')};
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    padding-left: 40px;
  }
`;

S.Brand = styled(SS.Brand)`
  ${({ theme }) => css`
    ${_.get(theme, 'product.brand.customStyle', '')}
  `}
`;

S.DescriptionShort = styled.div`
  line-height: 1.7em;
  margin: 0;
`;

S.ActionBlock = styled(SS.Block)`
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #eee;
  border-left: none;
  border-right: none;
  padding: 15px 0;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: none;
    padding: 5px 0;
  }
`;

S.ActionText = styled.span`
  color: ${({ theme }) => _.get(theme, 'colors.black')};
  margin-right: 20px;
  &:last-child {
    margin-right: 0;
  }
`;

S.AvailabilityWrapper = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;
`;

S.Button = styled(Button)``;

const ActionText = ({
  label,
  content
}) => {
    if (!content) {
      return null;
    }
    return (
      <S.ActionText><b>{label}:</b> {content}</S.ActionText>
    );
};

const PriceRequestModal = ({ product = null }) => {
  if (!product) {
    return null;
  }

  return (
    <Modal modalId={"product_price_request_" + product.id} title={_.get(product, 'name', 'request price')}>
      <Block margin="0">
        <RequestPriceForm product={product} />
      </Block>
    </Modal>
  )
}

// MURAT
class ProductDetailVariant2 extends PureComponent {
  onClickShowMore = (e) => {
    const { scrollToDescription } = this.props;
    e.preventDefault();
    scrollToDescription();
  }
  onShowModalClick = (e) => {
    const { dispatchShowModal } = this.props;
    e.preventDefault();
    dispatchShowModal(this.props);
  };
  render() {
    const {
      id,
      brand,
      name,
      subtitle,
      ean,
      partNo,
      sku,
      shortProductDescription,
      finalPriceData,
      variants,
      productHooks = [],
      isLocked,
      scrollToDescription,
      t
    } = this.props;
    const productHooksFiltred = _.filter(
      productHooks,
      hook =>
        hook.type === PRODUCT_DICOUNT_HOOK_TYPE ||
        hook.type === PRODUCT_SOFT_HOOK_TYPE
    );
    return (
      <S.SummaryWrapper>
        {!_.isEmpty(brand) ? <S.Brand>{brand.name}</S.Brand> : ''}
        <Headline1 color={'black'}>{name}</Headline1>
        {!_.isEmpty(subtitle) ? <SS.Subtitle>{subtitle}</SS.Subtitle> : ''}
        <S.ActionBlock>
          <S.AvailabilityWrapper>
            <ProductStatus product={this.props} />
          </S.AvailabilityWrapper>
          {/* <ActionText label={t('ean')} content={ean} /> */}
          <ActionText label={t('partNo')} content={partNo} />
          <ActionText label={t('sku')} content={sku} />
          <Rating />
          <AddToWishlist t={t} productId={id} title={''} customStyle={{link:{marginRight: '10px'}}} />
          <AddToCompare t={t} productId={id} title={''} />
        </S.ActionBlock>
        {!isLocked ? (
          <Fragment>
            {!_.isEmpty(shortProductDescription) ? (
              <BlockTransparent margin={'20px 0'} paddingConfig={{}}>
                <S.DescriptionShort
                  dangerouslySetInnerHTML={{
                    __html: shortProductDescription.description
                  }}
                />
                {scrollToDescription ? (
                  <Link href="#" onClick={this.onClickShowMore}>
                    {capfl(t('show more'))}
                  </Link>
                ) : (
                  ''
                )}
              </BlockTransparent>
            ) : (
              ''
            )}
            {_.get(finalPriceData, 'price', 0) > 0 ? (
              !_.isEmpty(variants) ? (
                <Variants data={this.props} productHooks={productHooksFiltred} />
              ) : (
                <ProductForm product={this.props} productHooksFiltered={productHooksFiltred} />
              )
            ) : (
              <Fragment>
                <S.Button onClick={this.onShowModalClick}>{capfl(t('request price'))}</S.Button>
                <PriceRequestModal product={this.props} />
              </Fragment>
            )}
          </Fragment>
        ) : (
          <Alert type={"text"}>
            <Trans i18nKey="productB2BLocked">
              <strong><Emoji label={'locker icon'}>🔒</Emoji> Information notice</strong>
              <p>Further information as a price, description and ability to order product is restricted to logged in users.</p>
            </Trans>
            <RouteLink route="login">{t('login')} / {t('register')}</RouteLink>
          </Alert>
        )}
      </S.SummaryWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatchShowModal: (product) => {
      dispatch(togglePageModal('product_price_request_' + _.get(product, 'id'), true));
    }
  };
};

const ProductDetailVariant2Connected = connect(
  undefined,
  mapDispatchToProps
)(ProductDetailVariant2);

export default ProductDetailVariant2Connected;
